// Frase de retorno do "reenviar mensagens com erro".
//
// A ação nem sempre reenfileira tudo: fica de fora o que já saiu e pode ter
// chegado ao destinatário — reenviar geraria uma segunda mensagem. Na Meta
// Oficial isso hoje significa mensagem com sinal de ENTREGA: quando a própria
// Meta declara a falha (status 'failed'), ninguém recebeu nada e o master
// devolve a mensagem para a fila normalmente. Antes o painel dizia
// "sucesso" em qualquer caso, então o cliente clicava, não via nada mudar no
// relatório e clicava de novo. Aqui a frase diz o que de fato aconteceu.
//
// As contagens vêm do master (resendMessageError). Se a resposta não trouxer os
// campos — servidor ainda não atualizado —, devolvemos null e quem chama mantém
// a mensagem antiga, sem quebrar.

function pluralizar(quantidade, singular, plural) {
  return quantidade === 1 ? singular : plural
}

export function montarFeedbackReenvio(resposta) {
  const reenfileiradas = Number(resposta?.reenfileiradas)
  const jaEnviadas = Number(resposta?.jaEnviadas)

  if (!Number.isFinite(reenfileiradas) || !Number.isFinite(jaEnviadas)) {
    return null
  }

  if (reenfileiradas === 0 && jaEnviadas === 0) {
    return 'Nenhuma mensagem com erro para reenviar.'
  }

  const partes = []

  if (reenfileiradas > 0) {
    partes.push(
      `${reenfileiradas} ${pluralizar(reenfileiradas, 'mensagem recolocada', 'mensagens recolocadas')} na fila.`
    )
    // O master pede ao servidor do número que reinicie a conexão para a fila
    // andar na hora. Se ele reiniciou há pouco (espera de 5 min) ou não
    // respondeu, as mensagens já estão na fila e saem sozinhas pelo varredor —
    // sem este aviso o cliente clicava de novo achando que tinha falhado.
    if (resposta?.reinicio === 'aguardando' || resposta?.reinicio === 'falhou') {
      partes.push('Elas saem automaticamente nos próximos minutos, sem precisar reenviar de novo.')
    }
  } else {
    partes.push('Nenhuma mensagem foi recolocada na fila.')
  }

  if (jaEnviadas > 0) {
    partes.push(
      `${jaEnviadas} não ${pluralizar(jaEnviadas, 'pôde', 'puderam')} ser reenviada${jaEnviadas === 1 ? '' : 's'}: ${pluralizar(jaEnviadas, 'já saiu', 'já saíram')} e o reenvio duplicaria a mensagem para o destinatário — veja o motivo da falha em cada uma.`
    )
  }

  return partes.join(' ')
}

export default montarFeedbackReenvio
